import React from 'react'
import { FieldValues, useController } from 'react-hook-form'

import { IInputSMBProps, Input } from '../InputSMB'
import { InputControlledProps } from './types'

export const InputControlled = <T extends FieldValues>(props: InputControlledProps<T>) => {
  const {
    control,
    name,
    helperText,
    transform = (value) => value,
    changeHandler,
    handleBlur,
    isOnlyNumbers,
    ...rest
  } = props

  const {
    field: { ref, value, onChange, onBlur },
    fieldState: { invalid, error },
  } = useController({
    name,
    control,
  })

  const fieldChangeHandler: IInputSMBProps['onChange'] = (event) => {
    const newValue = transform(event.target.value)

    if (isOnlyNumbers && isNaN(Number(newValue))) {
      return
    }

    onChange(newValue)
    changeHandler?.(newValue)
  }

  const fieldBlurHandler: IInputSMBProps['onBlur'] = () => {
    onBlur()
    handleBlur?.()
  }

  return (
    <Input
      ref={ref}
      value={value}
      onChange={fieldChangeHandler}
      onBlur={fieldBlurHandler}
      error={invalid}
      errorMessage={error?.message}
      helperText={helperText}
      {...rest}
    />
  )
}
